// Aplica o tema (claro/escuro) ao Highcharts.
//
// A moldura dos graficos ja desenhados (texto, eixo, legenda, tooltip, bordas) troca
// pelo CSS, em src/utils/styles/theme-charts.scss. Aqui sobra so o que o CSS nao alcanca:
//   - os defaults globais, para os graficos criados depois da troca nascerem certos;
//   - a escala de cor do mapa de calor, que e cor de dado e mora nas opcoes.
//
// Nada de chart.update com plotOptions: isso reprocessa todas as series e, com o volume
// real da dashboard, travava a troca de tema por segundos.
import Highcharts from 'highcharts'
import { buildChartTheme, chartHeatStops } from '@/utils/constants/ChartTheme'

function recolorHeatmap(chart: any): void {
  const isHeatmap = (chart.series || []).some((s: any) => s.type === 'heatmap')

  if (!isHeatmap || !chart.colorAxis || !chart.colorAxis.length) {
    return
  }

  // Token vazio (estilo ainda nao carregado) vira preto no Highcharts: nesse caso nao mexe
  const stops = chartHeatStops()

  if (stops.every(([, color]) => !!color)) {
    chart.colorAxis[0].update({ stops })
  }
}

export function applyChartTheme(): void {
  // Um `colorAxis` nos defaults globais cria um eixo de cor em TODO grafico: a legenda
  // ganha um quadradinho com degrade e a pizza sai preta. Nenhum default nosso tem um,
  // mas o Highcharts guarda os defaults em memoria (sobrevive a hot reload), entao a
  // garantia e explicita.
  delete (Highcharts.getOptions() as any).colorAxis

  Highcharts.setOptions(buildChartTheme())

  Highcharts.charts.forEach((chart: any) => {
    if (chart) {
      recolorHeatmap(chart)
    }
  })
}
